import { render, staticRenderFns } from "./TicketHeader.vue?vue&type=template&id=a30e4c88&scoped=true&"
import script from "./TicketHeader.vue?vue&type=script&lang=js&"
export * from "./TicketHeader.vue?vue&type=script&lang=js&"
import style0 from "./TicketHeader.vue?vue&type=style&index=0&id=a30e4c88&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30e4c88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
